import React from 'react';
import {useState} from "react";
import { LanguageLoader } from '../../assets/languages';
import { GetPortalStatusAPI } from '../../services/index.js';
import { SetLoginSettings } from '../../redux/actions/loginSettings.js';
import { useDispatch } from 'react-redux';

const Utype = () =>
{
	const language_config = localStorage.getItem('language') ? localStorage.getItem('language') : 'fa_IR';
	const language = LanguageLoader(language_config);
	const [tenant, SetTenant] = useState('');
	const dispatch = useDispatch();

	const GetPortalStatus = async (utype) =>
	{
		try
		{
			if(utype && utype.length)
			{
				const host = window.location.host;
				if(host.includes('.') && host.split('.')[0] === 'mobile')
				{
					localStorage.setItem('utype', utype);
					window.location.replace('/');
				}
				else
				{
					const APIResponse = await GetPortalStatusAPI(utype);
					if(APIResponse.status)
					{
						localStorage.setItem('utype', utype);
						localStorage.setItem('registration', APIResponse.registration);
						localStorage.setItem('notifyby', APIResponse.NotifyBy);
						if(APIResponse.login_page)
						{
							dispatch(SetLoginSettings(APIResponse.login_page));
						}
						window.location.replace('/');
					}
				}
			}
		}
		catch (ex) {}
	}


	return(
		<div>
			<div className="text-secondaryFont text-2xl font-medium text-center mt-14 absolute inset-x-0 -top-36">
				{language["AUTHENTICATION"]["TENANT_NAME"]}
			</div>
			<input type='text' autoCapitalize='off' id='tenant' className='text-center mb-5' defaultValue={tenant} onKeyDown={(e) => {if(e.key === "Enter") GetPortalStatus(tenant);}} onChange={(e) => SetTenant(e.target.value)} placeholder={language["AUTHENTICATION"]["TENANT_NAME"]}/>
			<button type='button' onClick={() => { GetPortalStatus(tenant); }} className='btn-primary mb-1 mt-30 w-full bg-primary text-secondaryFont'>{language["AUTHENTICATION"]["NEXT_STEP"]}</button>
		</div>
	);
}

export default Utype;